import Vue from 'vue'
import Vuetify from 'vuetify/lib'

// console.log(`Vuetify: ${Vuetify.version}`)

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#105880',
        accent: '#96be3d',
        secondary: '#96be3d',
        info: '#59a7d2',
        warning: '#fb6340',
        error: '#eb353f',
        success: '#96be3d',
      }
    }
  }
}

export default new Vuetify(opts)
